import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { CalendarIcon } from "@phosphor-icons/react";

export type Period = { days: number; label: string };

export const PERIODS: Period[] = [
  { days: 7, label: "7 derniers jours" },
  { days: 30, label: "30 derniers jours" },
  { days: 90, label: "90 derniers jours" },
  { days: 365, label: "12 derniers mois" },
];

/** The same windows with the last day or two in front, for pages read day to day. */
export const SHORT_PERIODS: Period[] = [
  { days: 1, label: "24 dernières heures" },
  { days: 2, label: "48 dernières heures" },
  ...PERIODS,
];

export function PeriodSelect({
  days,
  onChange,
  periods = PERIODS,
}: {
  days: number;
  onChange: (days: number) => void;
  periods?: Period[];
}) {
  return (
    <Select value={String(days)} onValueChange={(v) => onChange(Number(v))}>
      <SelectTrigger className="w-[220px]">
        <div className="flex items-center gap-2">
          <CalendarIcon
            className="h-5 w-5 text-muted-foreground shrink-0"
            weight="fill"
          />
          <SelectValue />
        </div>
      </SelectTrigger>
      <SelectContent>
        {periods.map((p) => (
          <SelectItem key={p.days} value={String(p.days)}>
            {p.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
